import React, { useState, useEffect, useContext, useRef } from "react";
import FileUploadComponent from "../components/FileUploadComponent";
import { AppContext } from "../AppContextProvider";
import google_logo from "../assets/media/icons/social/google.png";
import amazon_logo from "../assets/media/icons/social/amazon.png";
import instagram_logo from "../assets/media/icons/social/instagram.png";
import whatsapp_logo from "../assets/media/icons/social/whatsapp.png";
import social1_logo from "../assets/media/icons/social/social1.png";
import social2_logo from "../assets/media/icons/social/social2.png";

import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalFooter,
  MDBModalBody,
  MDBBtn,
  MDBModalHeader,
  MDBModalTitle,
  MDBSelect,
} from "mdb-react-ui-kit";

export default function MetaDownloadHelpModal(props) {
  const context = useContext(AppContext);
  const [isFiles, setIsFiles] = useState(false);
  const [plattformText, setPlattformText] = useState("Amazon");

  return (
    <>
      <MDBModal staticBackdrop tabIndex="-1" closeOnEsc={false} show={props.visible} className="file-download-modal">
        <MDBModalDialog scrollable centered size="lg">
          <MDBModalContent>
            <MDBModalHeader>
              <div className="select-menu">
                <MDBSelect
                  data={[
                    { text: "Amazon", value: 1 },
                    { text: "Google", value: 2 },
                    { text: "Instagram", value: 3 },
                  ]}
                  onValueChange={(val) => setPlattformText(val.text)}
                />
              </div>
              <button
                type="button"
                className="button outline medium"
                onClick={() => props.hideModal()}
                style={{ minWidth: "unset" }}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.06056 8.00001L11.5303 5.53028C11.8233 5.23731 11.8233 4.7627 11.5303 4.46973C11.2373 4.17676 10.7627 4.17676 10.4697 4.46973L8.00001 6.93946L5.53028 4.46973C5.23731 4.17676 4.7627 4.17676 4.46973 4.46973C4.17676 4.7627 4.17676 5.23731 4.46973 5.53028L6.93946 8.00001L4.46973 10.4697C4.17676 10.7627 4.17676 11.2373 4.46973 11.5303C4.61621 11.6768 4.80762 11.75 5 11.75C5.19238 11.75 5.38379 11.6768 5.53027 11.5303L8 9.06056L10.4697 11.5303C10.6162 11.6768 10.8076 11.75 11 11.75C11.1924 11.75 11.3838 11.6768 11.5303 11.5303C11.8232 11.2373 11.8232 10.7627 11.5303 10.4697L9.06054 8.00001H9.06056Z"
                    fill="#2BBCD9"
                  />
                </svg>
              </button>
            </MDBModalHeader>
            <MDBModalBody>
              {plattformText === "Amazon" && (
                <div className="info-table">
                  <div className="info-icon">
                    <div className="socials-div">
                      <div className="socials-image">
                        <img src={amazon_logo} alt="amazon" />
                      </div>
                    </div>
                  </div>
                  <div className="info-text">
                    <p>Export personal data from Amazon</p>
                    <ol style={{ listStyleType: "decimal" }}>
                      <li>Go to Amazon - Request your data</li>
                      <li>Under Select Data Category select Request All Your Data, then click on Submit Request</li>
                      <li>
                        Check your inbox for a new confirmation email from Amazon. Click on the confirmation link in the
                        email to confirm your request.
                      </li>
                      <li>
                        You will now see a Data Request Confirmation page. While it can take up to a month for your
                        personal data archive to become available, you should typically receive a download link within 4
                        to 5 days.
                      </li>
                      <li>
                        Download the data archive through the link in the email and save it to your local storage.
                      </li>
                    </ol>
                  </div>
                </div>
              )}
              {plattformText === "Google" && (
                <div className="info-table">
                  <div className="info-icon">
                    <div className="socials-div">
                      <div className="socials-image">
                        <img src={google_logo} alt="amazon" />
                      </div>
                    </div>
                  </div>
                  <div className="info-text">
                    <p>Export personal data from Google</p>
                    <ol style={{ listStyleType: "decimal" }}>
                      <li>
                        Go to{" "}
                        <a href="https://takeout.google.com" target="_blank" rel="noreferrer">
                          Google Takeout
                        </a>
                      </li>
                    </ol>
                  </div>
                </div>
              )}
              {plattformText === "Instagram" && (
                <div className="info-table">
                  <div className="info-icon">
                    <div className="socials-div">
                      <div className="socials-image">
                        <img src={instagram_logo} alt="amazon" />
                      </div>
                    </div>
                  </div>
                  <div className="info-text">
                    <p>Export personal data from Instagram</p>

                    <ol style={{ listStyleType: "decimal" }}>
                      <li>
                        Go to{" "}
                        <a
                          href="https://accountscenter.instagram.com/info_and_permissions/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Instagram - Your information and permissions
                        </a>
                      </li>
                      <li>
                        Under <strong>Your information and permissions</strong> click on{" "}
                        <strong>Download your information</strong>
                      </li>
                      <li>
                        Under <strong>Download your information</strong> click on{" "}
                        <strong>Download or transfer information</strong>
                      </li>
                      <li>
                        Under <strong>How much information do you want?</strong> select{" "}
                        <strong>All available information</strong>
                      </li>
                      <li>
                        Under <strong>What do you want to do with your information?</strong> select{" "}
                        <strong>Download to device</strong>, then click on <strong>Next</strong>
                      </li>
                      <li>
                        Under <strong>Create files to download</strong>:
                        <ol type="a">
                          <li>
                            Under <strong>Date range</strong> select <strong>All time</strong>
                          </li>
                          <li>
                            Under <strong>Notify</strong> enter your email address
                          </li>
                          <li>
                            Under <strong>Format</strong> select <strong>JSON</strong>
                          </li>
                          <li>
                            Under <strong>Media quality</strong> keep the pre-selected option: <strong>Medium</strong>
                          </li>
                          <li>
                            Click on <strong>Create files</strong>
                          </li>
                        </ol>
                      </li>
                      <li>Wait until you get an email notification with a download link</li>
                      <li>Download the data archive through the link in the email and save it to your local storage</li>
                      <li>
                        Click on <strong>Next</strong> to upload the data archive from your local storage
                      </li>
                    </ol>
                  </div>
                </div>
              )}
            </MDBModalBody>
            <MDBModalFooter>
              <div className="info-div"></div>
              <div className="actions-button-div">
                <button
                  className="button subtle medium "
                  onClick={() => {
                    if (props.modalText === "fileuplodmodal") {
                      props.hideModal(), context.openModal("fileupload", "");
                    } else {
                      props.hideModal();
                    }
                  }}
                >
                  <span className="text">Close</span>
                </button>
              </div>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}
